<!-- <div class="row  text-justify " style="background:#e9eced "
  [ngStyle]="{'direction':this.apiService.currentDirection ==='rtl'? 'rtl': 'ltr'}" id='footer'>
  <div class="container px-3">

    <div class="container mx-auto pb-5 text text-center">

      <div class="d-flex justify-content-start">
        <h5 class="mt-4 mr-5 px-1 bold">{{'DownloadAlobodoApplication'|translate}}</h5>
      </div>
      <div class="d-flex justify-content-center mt-3 " style="border-radius: 5px;">

        <div class="col-10">
          <div class="col-6">
            <a href="https://play.google.com/store/apps/details?id=medis.holding.alobodoapp" target="_blank"
              class="btn border m-2  downloadLink" target="_blank">
              <div class="d-flex justify-content-around">
                <div class="mini ">
                  <img src="../../../assets/img/downloadLink/google-play.png" class="fade-in mini">
                </div>
                <div>
                  <p class="miniText">{{'GetItOn'|translate}}</p>
                  <p class="miniText bold"> {{'GooglePlay'|translate}} </p>
                </div>
              </div>
            </a>
            <a [href]=this.internalService.androidLink class="btn border m-2  downloadLink" target="_blank">
              <div class="d-flex justify-content-around">
                <div class="mini ">
                  <img src="../../../assets/img/downloadLink/android.png" class="fade-in mini">
                </div>

                <div>
                  <p class="miniText">{{'DirectDownload'|translate}}</p>
                  <p class="miniText bold">{{'AndroidVersion'|translate}}</p>
                </div>
              </div>
            </a>
          </div>

          <div class="col-6">
            <a (click)="open(modalDownLoad)" class="btn border m-2  downloadLink" target="_blank">
              <div class="d-flex justify-content-around">
                <div class="mini ">
                  <img src="../../../assets/img/downloadLink/appstore_logo.png" class="fade-in mini">
                </div>
                <div>
                  <p class="miniText">{{'GetItOn'|translate}}</p>
                  <p class="miniText bold">{{'AppleStore'|translate}}</p>
                </div>
              </div>

            </a>
            <a href="https://web.alobodo.com/" class="btn border m-2  downloadLink" target="_blank">
              <div class="d-flex justify-content-around">
                <div class="mini ">
                  <img src="../../../assets/img/downloadLink/globe.png" class="fade-in mini">
                </div>
                <div>
                  <p class="miniText">{{'LaunchAs'|translate}}</p>
                  <p class="miniText bold"> {{'WebApp'|translate}}</p>
                </div>
              </div>
            </a>
          </div>

        </div>

        <div class="col-2">
          <a referrerpolicy='origin' target='_blank'
            href='https://trustseal.enamad.ir/?id=458731&Code=mufZMFYRlnVCN3gFLo9re8F0W5X5SCZr'><img
              referrerpolicy='origin'
              src='https://trustseal.enamad.ir/logo.aspx?id=458731&Code=mufZMFYRlnVCN3gFLo9re8F0W5X5SCZr' alt=''
              style='cursor:pointer' Code='mufZMFYRlnVCN3gFLo9re8F0W5X5SCZr'></a>
        </div>

      </div>

    </div>
  </div>


  <div class="col-12" style="background: #ffc200">
    <div class="container" style="min-height: 60px">

      <div class="row pt-3">
        <div class="col-12 col-sm-4 col-md-4 col-lg-4 text-center  fadeInt "
          [ngStyle]="{'font-family' :this.apiService.currentDirection == 'ltr'? 'myriad_pro': 'sans-serif'}">
          <a href="https://www.medis.land/" target="_blank">
            <img src="../../../assets/img/medis.png" width="30">
          </a>

          {{'PoweredBy'|translate}}

          <span style="font-family:Arial, Helvetica, sans-serif;"> © {{ year }} </span>

        </div>

        <div class="col-12 col-sm-4 col-md-4 col-lg-4 fadeIn text-center pt-1">

          <span class="fadeIn">
            <a [routerLink]="['/terms']" class="px-3" target="_blank"> {{'Terms'|translate}} </a>
          </span>
          <span>|</span>
          <span class="fadeIn">
            <a [routerLink]="['/privacy']" class="px-3" target="_blank"> {{'Privacy'|translate}}</a>
          </span>

        </div>

        <div class="col-12 col-sm-4 col-md-4 col-lg-4 text-center pt-1"> -->

<!-- Footer Social Icons -->
<!-- <a href="https://www.instagram.com/alobodo.medis/" class="px-2" target="_blank">
            <i class="fa fa-instagram fa-lg"></i>
          </a>

          <a href="mailto:info@alobodo.com" class="px-2">
            <i class="fa fa-envelope-o fa-lg"></i>
          </a>

          <a href="tel:+987132318040" class="px-2" (click)="open(modal)">
            <i class="fa fa-phone fa-lg"></i>
          </a>

          <a class="px-2" [routerLink]="['/contact']">
            <i class="fa fa-map-marker  fa-lg"></i>
          </a>

        </div>

      </div>


    </div>
  </div>


</div>



<ng-template let-c="close" let-d="dismiss" #modal>
  <div class="modal-header" [dir]="apiService.currentDirection">
    {{'ContactInfo'|translate}}
  </div> -->
<!------------------  version ---------------------------------------->
<!-- <div class="modal-body frame"
    [ngStyle]="{'direction': this.apiService.currentDirection === 'rtl'? 'rtl': 'ltr', 'text-align': this.apiService.currentDirection === 'rtl'? 'right': 'left'}">
    <div class=" col-md-12">
      <ul class="contact-info" style="list-style: none">
        <li><i class="fa fa-phone" aria-hidden="true"></i></li>
        <li>
          <p class="" style="direction: ltr"
            [ngStyle]="{'text-align':apiService.currentDirection ==='ltr'?'left':'right'}">+98-71-3231-8040 </p>
        </li>
      </ul>
    </div>
    <div class="modal-footer">
      <div class="row d-flex justify-content-end">
        <button type="button" class="btn btn-primary custom-btn" (click)="d('Cross click')">{{'Close'|translate}}
        </button>

      </div>

    </div>

  </div>
</ng-template> -->


<!-------------------------------- link modal  ----------------------------------->
<ng-template class="modal" let-c="close" let-d="dismiss" #modalDownLoad let-modal>
  <div class="cookiesContent" id="cookiesPopup">
    <button (click)="d('Cross click')" class="close">✖</button>
    <img src="../../../assets/img/wrench.png" alt="cookies-img" />
    <p> {{'FixedLink' | translate}} </p>
    <button (click)="d('Cross click')" class="accept">{{'Close' | translate}}</button>
  </div>
</ng-template>















<!-- new Footer design -->


<div class="main-footer" [ngStyle]="{'direction':this.apiService.currentDirection ==='rtl'? 'rtl': 'ltr'}">
  <div class="container my-5">
    <div class="row d-flex justify-content-center mt-3">
      <div class="">
        <h4 class=" px-1 bold">{{'DownloadAlobodoApplication'|translate}}</h4>
      </div>
    </div>

    <div class="d-md-flex text-center justify-content-between px-3 m-3 " style="border-radius: 5px;">
      <a href="https://play.google.com/store/apps/details?id=medis.holding.alobodoapp" target="_blank"
        class="btn border m-2  downloadLink" target="_blank">
        <div class="d-flex justify-content-around">
          <div class="mini ">
            <img src="../../../assets/img/downloadLink/google-play.png" class="fade-in mini">
          </div>
          <div>
            <p class="miniText">{{'GetItOn'|translate}}</p>
            <p class="miniText bold"> {{'GooglePlay'|translate}} </p>
          </div>
        </div>
      </a>
      <a [href]=this.internalService.androidLink class="btn border m-2  downloadLink" target="_blank">
        <div class="d-flex justify-content-around">
          <div class="mini ">
            <img src="../../../assets/img/downloadLink/android.png" class="fade-in mini">
          </div>

          <div>
            <p class="miniText">{{'DirectDownload'|translate}}</p>
            <p class="miniText bold">{{'AndroidVersion'|translate}}</p>
          </div>
        </div>
      </a>



      <a (click)="open(modalDownLoad)" class="btn border m-2  downloadLink" target="_blank">
        <div class="d-flex justify-content-around">
          <div class="mini ">
            <img src="../../../assets/img/downloadLink/appstore_logo.png" class="fade-in mini">
          </div>
          <div>
            <p class="miniText">{{'GetItOn'|translate}}</p>
            <p class="miniText bold">{{'AppleStore'|translate}}</p>
          </div>
        </div>

      </a>
      <a href="https://web.alobodo.com/" class="btn border m-2  downloadLink" target="_blank">
        <div class="d-flex justify-content-around">
          <div class="mini ">
            <img src="../../../assets/img/downloadLink/globe.png" class="fade-in mini">
          </div>
          <div>
            <p class="miniText">{{'LaunchAs'|translate}}</p>
            <p class="miniText bold"> {{'WebApp'|translate}}</p>
          </div>
        </div>
      </a>

    </div>

    <div class="d-flex justify-content-between px-4 m-3">
      <div class="col-12 mt-3 mx-auto boxShadow contactInfo"
        [ngStyle]="{'text-align':this.apiService.currentDirection === 'rtl'? 'right':'left'}">
        <div class="row">
          <div class="col-12 p-3">
            <h4 class="bold ">{{'ContactUs'|translate}}</h4>
            <div class="row ">
              <div class="col-md-6 col-12">
                <label class="text-black" for="fname">{{'Name'|translate}} </label>
                <input type="text" [(ngModel)]="name" id="fname" class="form-control rounded-0" required>
              </div>
              <div class="col-md-6 col-12">
                <label class="text-black" for="fname">{{'Email'|translate}} </label>
                <input type="text" [(ngModel)]="email" id="email" class="form-control rounded-0" required>
              </div>
            </div>
            <div class="row col-12" style="display:contents;">
              <label class="text-black" for="description"> {{'Message'|translate}}</label>
              <textarea name="description" [(ngModel)]="message" id="description" cols="30" rows="5"
                class="form-control rounded-0" placeholder=""></textarea>
            </div>
            <div class="d-flex justify-content-end">
              <button class="btn ptn-primary custom-btn mt-3" (click)="sendFeedback()">{{'Send'|translate}}</button>
            </div>

          </div>
        </div>
      </div>
    </div>


    <div class="info-lg">
      <div class="d-flex justify-content-between"
        style="position:relative; border-bottom: 1px solid #ccc;margin: 0 40px 0 40px;">
        <div class="row col-12 px-2">
          <div class="col-md-8 col-12 p-0">
            <div class="col-12 fadeIn d-flex justify-content-between p-0">

              <span class="fadeIn">
                <a [routerLink]="['/terms']" class="px-3 link-page" target="_blank"> {{'Terms'|translate}} </a>
              </span>

              <span class="fadeIn">
                <a [routerLink]="['/privacy']" class="px-3 link-page" target="_blank"> {{'Privacy'|translate}}</a>
              </span>

              <span class="fadeIn">
                <a [routerLink]="['/services/0']" class="px-3 link-page" target="_blank"> {{'Services'|translate}} </a>
              </span>

              <span class="fadeIn">
                <a href="https://web.alobodo.com/" class="px-3 link-page" target="_blank"> {{'SignIn'|translate}}</a>
              </span>

            </div>
          </div>
          <div class="col-md-4 col-12 px-1 ">
            <div class="col-12 p-0 fadeInt " [ngStyle]="{'font-family' :this.apiService.currentDirection == 'ltr'? 'myriad_pro': 'sans-serif',
                        'margin' :this.apiService.currentDirection == 'ltr'?'0 0 0 120px':'0 18px 0 0'}">
              <a href="https://www.medis.studio/" target="_blank">
                <img src="../../../assets/img/medis.png" width="30">
              </a>

              {{'PoweredBy'|translate}}

              <span style="font-family:Arial, Helvetica, sans-serif;"> © {{ year }} </span>

            </div>
          </div>
        </div>
      </div>

      <div class="container contact-info" style="position: relative; top: 10px;">
        <div class="row col-12 text-justify " [ngClass]="this.apiService.currentDirection === 'rtl'? 'pr-4 pl-0':'pl-4 pr-0'">
          <div class="col-md-5 col-12">
            <img src="../../../assets/img/downloadLink/location_on_FILL.svg" alt="">
            <span>{{'Address'|translate}} </span>

          </div>
          <div class="col-md-3 col-12" dir="ltr">
            <a href="mailto:info@alobodo.com">
              <img src="../../../assets/img/downloadLink/mail_FILL.svg" alt="">
              <span> info@alobodo.com</span>
            </a>
          </div>
          <div class="col-md-2 col-12" dir="ltr">
            <a href="https://www.instagram.com/alobodo.medis/">
              <img src="../../../assets/img/downloadLink/instagram-logo.svg" width="24px" alt="">
              <span> alobodo.medis</span>
            </a>
          </div>
          <div class="col-md-2 col-12" dir="ltr">
            <a href="tel:+987132318040">
              <img src="../../../assets/img/downloadLink/call_FILL.svg" alt="">
              <span> +987132318040 </span>
            </a>
          </div>
        </div>
      </div>

    <div class="e-namad">
      <a referrerpolicy='origin' target='_blank'
        href='https://trustseal.enamad.ir/?id=458731&Code=mufZMFYRlnVCN3gFLo9re8F0W5X5SCZr'><img referrerpolicy='origin'
          src='https://trustseal.enamad.ir/logo.aspx?id=458731&Code=mufZMFYRlnVCN3gFLo9re8F0W5X5SCZr' alt=''
          style='cursor:pointer' Code='mufZMFYRlnVCN3gFLo9re8F0W5X5SCZr'></a>
    </div>
  </div>


  <div class="info-mb">
    <div class="d-flex justify-content-center"
      style="position:relative; border-bottom: 1px solid #ccc;margin: 0 40px 0 40px;">
      <div class="row col-12 px-2">
        <div class="col-md-8 col-12 p-0">
          <div class="col-12 fadeIn p-0 text-center" >

            <span class="fadeIn">
              <a [routerLink]="['/terms']" class=" link-page" target="_blank"> {{'Terms'|translate}} </a>
            </span>

            <span class="fadeIn col-6">
              <a [routerLink]="['/privacy']" class=" link-page" target="_blank"> {{'Privacy'|translate}}</a>
            </span>

            <span class="fadeIn col-6">
              <a [routerLink]="['/services/0']" class=" link-page" target="_blank"> {{'Services'|translate}} </a>
            </span>

            <span class="fadeIn col-6">
              <a href="https://web.alobodo.com/" class=" link-page" target="_blank"> {{'SignIn'|translate}}</a>
            </span>

          </div>
        </div>

      </div>
    </div>

    <div class="container " style="position: relative; top: 10px;">
      <div class="row col-12 text-center px-2">
        <div class="col-md-5 col-12">
          <img src="../../../assets/img/downloadLink/location_on_FILL.svg" alt="">
          <span> {{'Address'|translate}} </span>

        </div>
        <div class="col-md-3 col-12" dir="ltr">
          <a href="mailto:info@alobodo.com">
            <img src="../../../assets/img/downloadLink/mail_FILL.svg" alt="">
            <span> info@alobodo.com</span>
          </a>
        </div>
        <div class="col-md-2 col-12" dir="ltr">
          <a href="https://www.instagram.com/alobodo.medis/">
            <img src="../../../assets/img/downloadLink/instagram-logo.svg" width="24px" alt="">
            <span> alobodo.medis</span>
          </a>
        </div>
        <div class="col-md-2 col-12" dir="ltr">
          <a href="tel:+987132318040">
            <img src="../../../assets/img/downloadLink/call_FILL.svg" alt="">
            <span> +987132318040 </span>
          </a>
        </div>
      </div>
    </div>

    <div class="container d-flex justify-content-center" style="position: relative; top: 20px;">
      <div class="">
        <a referrerpolicy='origin' target='_blank'
          href='https://trustseal.enamad.ir/?id=458731&Code=mufZMFYRlnVCN3gFLo9re8F0W5X5SCZr'><img
            referrerpolicy='origin'
            src='https://trustseal.enamad.ir/logo.aspx?id=458731&Code=mufZMFYRlnVCN3gFLo9re8F0W5X5SCZr' alt=''
            style='cursor:pointer' Code='mufZMFYRlnVCN3gFLo9re8F0W5X5SCZr'></a>
      </div>
    </div>
    <div class="container " style="position: relative; top: 30px;">
      <div class="col-md-4 col-12 px-1 ">
        <div class="col-12 p-0 fadeInt d-flex justify-content-center m-0" [ngStyle]="{'font-family' :this.apiService.currentDirection == 'ltr'? 'myriad_pro': 'sans-serif',
                      'margin' :this.apiService.currentDirection == 'ltr'?'0 0 0 120px':'0 18px 0 0'}">
          <a href="https://www.medis.studio/" target="_blank">
            <img src="../../../assets/img/medis.png" width="30">
          </a>

          {{'PoweredBy'|translate}}

          <span style="font-family:Arial, Helvetica, sans-serif;"> © {{ year }} </span>

        </div>
      </div>
    </div>
  </div>
</div>



</div>